import Marquee3k from 'marquee3000'

const tickers = document.querySelectorAll('.element-logoticker')

const fn = {
  init: () => {
    setTimeout(Marquee3k.init, 500)
  },
}

export default {
  can: () => tickers.length,
  run: fn.init,
}
